// DOM helpers for the loading spinner and end-of-list indicator used by LazyLoadManager.

import { SEARCH_LIMIT } from './constants.js';
import { translateKey } from './translate.js';

// Build both indicator elements and append them after the file-list container.
// Returns { loadingIndicator, endIndicator } or null if container has no parent.
export function createIndicators(container) {
    const loadingIndicator = document.createElement('div');
    loadingIndicator.className = 'lazy-load-indicator lazy-load-indicator--loading p-3 text-center';
    loadingIndicator.style.display = 'none';
    loadingIndicator.innerHTML = `
        <div class="spinner-border spinner-border-sm text-primary me-2" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <span class="text-muted">Loading more files...</span>
    `;

    const endIndicator = document.createElement('div');
    endIndicator.className = 'lazy-load-indicator lazy-load-indicator--end p-3 text-center text-muted';
    endIndicator.style.display = 'none';
    // Body is set on showEndIndicator() depending on whether the cap was reached.
    endIndicator.innerHTML = `<small></small>`;

    if (!container.parentElement) {
        console.error('[LazyLoadManager] ❌ Container has no parent element!');
        return null;
    }

    container.parentElement.appendChild(loadingIndicator);
    container.parentElement.appendChild(endIndicator);

    return { loadingIndicator, endIndicator };
}

export function showLoadingIndicator(el) {
    if (!el) {
        console.error('[LazyLoadManager] ❌ No loading indicator to show!');
        return;
    }
    el.style.display = 'block';
    el.classList.remove('is-idle');
}

export function hideLoadingIndicator(el) {
    if (!el) return;
    el.style.display = 'none';
    el.classList.add('is-idle');
}

// "Idle" state: visible but without active spinner — armed for next IO trigger.
export function setLoadingIndicatorIdle(el) {
    if (!el) return;
    el.style.display = 'block';
    el.classList.add('is-idle');
}

// Show end-of-list message. Two flavors:
//   - SEARCH_LIMIT cap reached: "<n>+ files. Refine query."
//   - All loaded: "All loaded (<n> total)"
export function showEndIndicator(el, displayedCount, allFilesLength) {
    if (!el) {
        console.error('[LazyLoadManager] ❌ No end indicator to show!');
        return;
    }

    const isLimitReached = allFilesLength > SEARCH_LIMIT;
    let message;
    if (isLimitReached) {
        const shownText = translateKey('files_shown_limit');
        const filesText = translateKey('files_plural');
        const refineText = translateKey('files_refine_query');
        message = `<small>${shownText} ${displayedCount}+ ${filesText}. <span class="text-muted">${refineText}</span></small>`;
    } else {
        const allLoadedText = translateKey('files_all_loaded');
        const totalText = translateKey('files_total');
        message = `<small>${allLoadedText} (${displayedCount} ${totalText})</small>`;
    }

    el.innerHTML = message;
    el.style.display = 'block';
}

export function hideEndIndicator(el) {
    if (!el) return;
    el.style.display = 'none';
}
